import { SvgIcon } from "@mui/material";

export const Rocket = (props: any) => {
  return (
    <SvgIcon fontSize="1rem" viewBox="0 0 21 21" {...props}>
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.25 13.7502L7.25 10.7502M10.25 13.7502C11.6468 13.219 12.9869 12.549 14.25 11.7502M10.25 13.7502V18.7502C10.25 18.7502 13.28 18.2002 14.25 16.7502C15.33 15.1302 14.25 11.7502 14.25 11.7502M7.25 10.7502C7.78214 9.36968 8.4522 8.04631 9.25 6.80025C10.4152 4.93723 12.0376 3.4033 13.963 2.34434C15.8884 1.28538 18.0527 0.736619 20.25 0.750248C20.25 3.47025 19.47 8.25025 14.25 11.7502M7.25 10.7502H2.25C2.25 10.7502 2.8 7.72025 4.25 6.75025C5.87 5.67025 9.25 6.75025 9.25 6.75025M2.75 15.2502C1.25 16.5102 0.75 20.2502 0.75 20.2502C0.75 20.2502 4.49 19.7502 5.75 18.2502C6.46 17.4102 6.45 16.1202 5.66 15.3402C5.27131 14.9693 4.75929 14.7549 4.22223 14.7383C3.68516 14.7217 3.16088 14.904 2.75 15.2502Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};
